// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";
import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { reset } from "../../utils/commonJssConstants";

export const UGContentCreateView2Styles = (config: DesignSystem)=> ({
    ugContentCreateView2Container: {
        ...reset,
        "margin-top": "24px",

        "& .cwt-content-generation-form": {
            display: "flex",
            "flex-direction": "column",
            "align-items": "center"
        },

        "& .cwt-text-input-group": {
            display: "flex",
            "flex-direction": "column",
            width: "800px",
            "max-width": "100%"
        },

        "& .cwt-label": {
            "font-size": "14px",
            "font-weight": "600",

            "& + .cwt-input": {
                [applyLocalizedProperty("margin-left", "margin-right", config.direction)]: "-8px"
            }
        },

        "& .cwt-input": {
            "margin-bottom": "24px"
        }
    }
});